import { useCallback, useState } from "react";
import { resumeCampaign, stopCampaign } from "../../../../../api/StatsAPI";
import { notifications } from "@mantine/notifications";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { Button, Loader } from "@mantine/core";
import {
  IconCircleOff,
  IconPlayerPauseFilled,
  IconPlayerPlayFilled,
} from "@tabler/icons-react";

const ToggleCampaign = ({ apiRef, current }) => {
  const lang = useLanguage((s) => s.language);
  const [switching, setSwitching] = useState(false);

  const handleSwitch = useCallback(() => {
    setSwitching(true);

    let func = current.stopped ? resumeCampaign : stopCampaign;

    func(current.workflow_id, current.id)
      .then((response) => {
        apiRef.current.updateRows([
          { id: current.id, _action: "delete" },
          { id: `#${current.id}`, _action: "delete" },
        ]);
        notifications.show({
          message: current.stopped
            ? lang.statistics.row_highlight.created
            : lang.statistics.row_highlight.updated,

          color: "tertiary.8",
        });
      })
      .finally(() => setSwitching(false));
  }, [apiRef, current, lang]);

  return (
    <Button
      variant="subtle"
      disabled={!current.write_permission}
      justify="start"
      to={
        !current.write_permission
          ? null
          : `/campaign/edit/${current.id}/workflow/${current.workflow_id}`
      }
      leftSection={
        !current.write_permission ? (
          <IconCircleOff size={18} color="black" />
        ) : switching ? (
          <Loader type="oval" size={14} />
        ) : current.stopped ? (
          <IconPlayerPlayFilled
            size={18}
            color="var(--mantine-color-green-7)"
          />
        ) : (
          <IconPlayerPauseFilled size={18} color="var(--mantine-color-red-7)" />
        )
      }
      onClick={handleSwitch}
    >
      {current.stopped
        ? "Reprendre l'envoi de la campagne"
        : "Mettre en pause la campagne"}
      {/* {lang.workflows.edit} */}
    </Button>
  );
};

export default ToggleCampaign;
